import React from "react";
import {Link} from "react-router-dom";
import {
    IconButton,
    makeStyles,
    Typography
} from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Table from "@material-ui/core/Table";
import TableContainer
    from "@material-ui/core/TableContainer";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {Delete, Edit} from "@material-ui/icons";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon
    from "@material-ui/icons/CheckCircle";
import RemoveCircleRoundedIcon
    from "@material-ui/icons/RemoveCircleRounded";
import styled from "styled-components";
import {
    usePagination,
    useRowSelect,
    useTable
} from "react-table";
import apiHelper from "../../../util/ApiHelper";
import {CustomCheckbox, modal} from "../../../util";
import {useLoading} from "../../../util/LoadingProvider";
import {toast} from "react-toastify";
import EmailTemplateListing
    from "./components/EmailTemplateListing";
import EmailTemplateEdit
    from "./components/EmailTemplateEdit";
import SenderSettings from "./components/SenderSettings";
import {
    PaginationHandler
} from "../../../util/useManualPagination";
import PaginationBarForHandler from "../../common/PaginationBarForHandler";

const useStyles = makeStyles((theme) => ({
    tabpanel: {
        background: "#FFFFFF",
    },
    textInput: {
        backgroundColor: "white",
        width: "100%",
        marginBottom: "12px",

        "& input": {
            fontSize: "14px",
        },
    },
    content: {
        "& .ck-editor__editable_inline": {
            minHeight: "200px",
        },
    },
    buttonGroup: {
        marginTop: "20px",
        textAlign: "right",
        "& button": {
            color: "#306F9D",
            fontSize: "13px",
            textTransform: "inherit",
        },
    },
    box: {
        padding: 0,
        background: "#ffffff",
        paddingTop: "10px",
        paddingBottom: "10px",
        minHeight: "800px",
    },
    innerBox: {
        background: "#ffffff",
        padding: theme.spacing(3),
        marginBottom: theme.spacing(4),
    },
    button: {
        backgroundColor: "#306F9D",
        textTransform: "capitalize",
        color: "white",
        "&:hover": {
            backgroundColor: "#306F9D",
        },
    },
    pagination: {
        "& .MuiTextField-root": {
            width: "35px",
            minWidth: "auto",
        },
        "& .MuiSelect-root": {
            paddingTop: "3px",
            paddingBottom: "3px",
        },
        "& input": {
            padding: "4px 0",
            marginLeft: "10px",
            marginRight: "10px",
        },
        "& button": {
            background: "white",
            color: "#cccccc",
            border: "1px solid #CCCCCC",
            minWidth: "auto",
            width: "24px",
            height: "24px",
            margin: "4px 0",
            "&.left": {
                borderRadius: "4px 0 0 4px",
                marginLeft: "10px",
            },
            "&.right": {
                borderRadius: " 0 4px 4px 0",
            },
        },
    },
}));

const statuses = {
    0: "Waiting for Approval",
    1: "Approved (Self pick-up)",
    2: "Approved (Hotel)",
    3: "Rejected",
};

const nameTitles = {
    0: "Mr",
    1: "",
    2: "Ms",
    3: "Mrs",
    4: "Dr",
    5: "Miss",
};

const professionalCategories = {
    0: "Director/Scriptwriter/Cast/Producer/Distributor",
    1: "Festival Delegate",
    2: "Others",
};

const IndeterminateCheckbox = React.forwardRef(
    ({indeterminate, ...rest}, ref) => {
        const defaultRef = React.useRef();
        const resolvedRef = ref || defaultRef;

        React.useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate;
        }, [resolvedRef, indeterminate]);

        return <CustomCheckbox type="checkbox"
                               ref={resolvedRef} {...rest} />;
    }
);

function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
}

const StatusFilter = styled.ul`
  list-style: none;
  display: inline-flex;
  padding: 0;
  margin-left: 25px;

  li {
    button {
      border: 0px;
      background: transparent;
      color: #306f9d;
      font-size: 13px;
      line-height: 15px;
      padding: 0 10px;
      cursor: pointer;

      &.active {
        font-weight: bold;
        color: #333333;
      }
    }

    &:not(:last-of-type) {
      button {
        border-right: 1px solid black;
      }
    }

    &:first-of-type {
      button {
        padding-left: 0;
      }
    }
  }
`;

function TabPanel(props) {
    const classes = useStyles();
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            <Box p={3} className={classes.box}>
                {children}
            </Box>
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `nav-tab-${index}`,
        "aria-controls": `nav-tabpanel-${index}`,
    };
}

function GuestAccreditationPage(props) {
    const {match} = props;
    const classes = useStyles();
    const [disabled, setDisabled] = React.useState(props.disabled);
    const [activeTab, setActiveTab] = React.useState(0);
    const [actionType, setActionType] = React.useState("");
    const [editEmailTemplate, setEditEmailTemplate] = React.useState(false);
    const [keyword, setKeyword] = React.useState("");
    const [queryString, setQueryString] = React.useState("");
    const [data, setData] = React.useState([]);
    const [totalPages, setTotalPages] = React.useState(1);
    const [status, setStatus] = React.useState(null);
    const [paginationHandler] = React.useState(new PaginationHandler());
    const {setLoading} = useLoading();

    // for pagination
    const [elementCounts, setElementCounts] = React.useState({
        all: 0,
        [statuses[0]]: 0,
        [statuses[1]]: 0,
        [statuses[2]]: 0,
        [statuses[3]]: 0,
    });

    const CustomLink = React.useMemo(
        () =>
            React.forwardRef((linkProps, ref) => <Link
                ref={ref} {...linkProps} />),
        []
    );

    const handleSelectChange = (e) => {
        setActionType(e.target.value);
    };

    const handleImportPasscode = React.useCallback(() => {
        // Trigger file input click
        const fileInput = document.getElementById('import-passcode-file');
        if (fileInput) {
            fileInput.click();
        }
    }, []);

    const handleFileUpload = React.useCallback(async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Check if file is Excel format
        const allowedTypes = [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel.sheet.macroEnabled.12'
        ];
        
        if (!allowedTypes.includes(file.type) && !file.name.match(/\.(xlsx|xls)$/i)) {
            toast.error("Please select an Excel file (.xlsx or .xls)");
            return;
        }

        try {
            setLoading(true);
            // 本地开发时使用本地API，生产环境使用环境变量配置的API
            const apiUrl = process.env.NODE_ENV === 'development' 
                ? "http://localhost:8555"
                : (process.env.REACT_APP_API_HOSTNAME || "https://hkiff-api-uat.cloud.udev.hk");
            
            const formData = new FormData();
            formData.append('file', file);
            
            const response = await fetch(`${apiUrl}/hkiff/admin/guest-accreditation/importPasscode`, {
                method: 'POST',
                body: formData,
                credentials: 'include', // This will include cookies for authentication
            });

            if (response.ok) {
                toast.success("Passcode imported successfully!");
                // Refresh the data after successful import
                window.location.reload();
            } else {
                const errorData = await response.json();
                toast.error(
                    <div>
                        <div>Failed to import passcode:</div>
                        <div style={{ whiteSpace: 'pre-line' }}>
                            {errorData.message}
                        </div>
                    </div>
                );
            }
        } catch (error) {
            console.error("Error importing passcode:", error);
            toast.error("Error importing passcode");
        } finally {
            setLoading(false);
            // Reset file input
            event.target.value = '';
        }
    }, [setLoading]);


    const columns = React.useMemo(
        () => [
            {
                Header: "Ref.#",
                accessor: "referenceNum",
                className: "col_referenceNum",
            },
            {
                Header: "Name Title",
                accessor: "title",
                Cell: ({row}) => {
                    return nameTitles[row.original.title]
                        ? nameTitles[row.original.title]
                        : "";
                },
            },
            {
                Header: "Surname",
                accessor: "surname",
            },
            {
                Header: "Given Name",
                accessor: "givenName",
            },
            {
                Header: "Country",
                accessor: "country",
            },
            {
                Header: "City",
                accessor: "city",
            },
            {
                Header: "Email",
                accessor: "email",
            },
            {
                Header: "Professional Category",
                accessor: "professionalCategory",
                Cell: ({row}) => {
                    return professionalCategories[row.original.professionalCategory]
                        ? professionalCategories[row.original.professionalCategory]
                        : "";
                },
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({row}) => {
                    if (row.original.status === 0) {
                        return (
                            <div style={{
                                display: "flex",
                                alignItems: "center"
                            }}>
                                <RemoveCircleRoundedIcon
                                    style={{
                                        color: "yellow",
                                        width: "12px"
                                    }}
                                />{" "}{statuses[0]}
                            </div>
                        );
                    }
                    if (row.original.status === 1) {
                        return (
                            <div style={{
                                display: "flex",
                                alignItems: "center"
                            }}>
                                <CheckCircleIcon style={{
                                    color: "green",
                                    width: "12px"
                                }}/>{" "}{statuses[1]}
                            </div>
                        );
                    }
                    if (row.original.status === 2) {
                        return (
                            <div style={{
                                display: "flex",
                                alignItems: "center"
                            }}>
                                <CheckCircleIcon style={{
                                    color: "green",
                                    width: "12px"
                                }}/>{" "}{statuses[2]}
                            </div>
                        );
                    }
                    if (row.original.status === 3) {
                        return (
                            <div style={{
                                display: "flex",
                                alignItems: "center"
                            }}>
                                <CancelIcon style={{
                                    color: "red",
                                    width: "12px"
                                }}/>{" "}{statuses[3]}
                            </div>
                        );
                    }
                    return "";
                },
                disableGlobalFilter: true,
            },
            {
                Header: "Payment Status",
                accessor: "paymentStatus",
                Cell: ({row}) => {
                    if (row.original.paymentStatus === 0) {
                        return (
                            <div style={{
                                display: "flex",
                                alignItems: "center"
                            }}>
                                <RemoveCircleRoundedIcon
                                    style={{
                                        color: "yellow",
                                        width: "12px"
                                    }}
                                />{" "}
                                Pending
                            </div>
                        );
                    }
                    if (row.original.paymentStatus === 1) {
                        return (
                            <div style={{
                                display: "flex",
                                alignItems: "center"
                            }}>
                                <CheckCircleIcon style={{
                                    color: "green",
                                    width: "12px"
                                }}/>{" "}
                                Confirmed
                            </div>
                        );
                    }
                    return "";
                },
                disableGlobalFilter: true,
            },
        ],
        [disabled]
    );

    const {
        getTableProps,
        headerGroups,
        rows,
        prepareRow,
        setPageSize,
        gotoPage,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        selectedFlatRows,
        state: {pageIndex, pageSize},
    } = useTable(
        {
            columns,
            data,
            initialState: {pageIndex: 0, pageSize: 10},
            manualPagination: true,
            pageCount: totalPages,
        },
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => [
                // Let's make a column for selection
                {
                    id: "selection",
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: ({getToggleAllRowsSelectedProps}) => (
                        <div>
                            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                        </div>
                    ),
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({row}) => (
                        <div>
                            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
                        </div>
                    ),
                },
                ...columns,
                {
                    id: "action",
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: () => <div>Action</div>,
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({row}) => (
                        <div
                            style={{display: "inline-flex"}}>
                            <IconButton
                                className={classes.iconBtn}
                                size="small"
                                component={CustomLink}
                                to={`${match.url}/${row.original.id}`}
                            >
                                <Edit fontSize="small"/>
                            </IconButton>
                            {disabled || (
                                <IconButton
                                    className={classes.iconBtn}
                                    size="small"
                                    onClick={() => {
                                        deleteAccreditation(row.original.id);
                                    }}
                                >
                                    <Delete
                                        fontSize="inherit"/>
                                </IconButton>
                            )}
                        </div>
                    ),
                },
            ]);
        }
    );

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 1) {
            window.history.replaceState(
                null,
                "Email Template",
                "/hkiff/guest-accreditation/email-template"
            );
        } else {
            window.history.replaceState(
                null,
                "Guest Accreditation",
                "/hkiff/guest-accreditation"
            );
        }
    };

    const getGuests = React.useCallback(async () => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.getGuests(
                "en",
                0,
                0,
                999999
            );
            paginationHandler.setPageIndex(0).setRows(result.data.content);
            const content = paginationHandler.filterRowsByAll().getRows();
            const newTotalPages = paginationHandler.getTotalPages();
            const counts = {
                all: paginationHandler.getStatuslessRows().length,
                [statuses[0]]: paginationHandler
                    .getStatuslessRows()
                    .filter((x) => x.status === 0).length,
                [statuses[1]]: paginationHandler
                    .getStatuslessRows()
                    .filter((x) => x && x.status && x.status === 1).length,
                [statuses[2]]: paginationHandler
                    .getStatuslessRows()
                    .filter((x) => x && x.status && x.status === 2).length,
                [statuses[3]]: paginationHandler
                    .getStatuslessRows()
                    .filter((x) => x && x.status && x.status === 3).length,
            }
            setElementCounts(counts);
            setData(content.filter((x) => x));
            setTotalPages(newTotalPages);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, [paginationHandler, setLoading]);

    React.useEffect(() => {
        if (match.url.startsWith("/hkiff/guest-accreditation/email-template")) {
            setActiveTab(1);
        }
        if (
            match.url.match(/^\/hkiff\/guest-accreditation\/email-template\/([^/])+$/)
        ) {
            setEditEmailTemplate(true);
        } else {
            setEditEmailTemplate(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (paginationHandler) getGuests(); // only get when paginationHandler ready
    }, [getGuests, paginationHandler]);

    const statusFilterHandler = (targetStatus) => () => {
        setLoading(true);
        setStatus(targetStatus);
        let target;
        if (targetStatus === statuses[0]) {
            target = 0;
        } else if (targetStatus === statuses[1]) {
            target = 1;
        } else if (targetStatus === statuses[2]) {
            target = 2;
        } else if (targetStatus === statuses[3]) {
            target = 3;
        } else {
            target = null;
        }
        paginationHandler
            .resetRows()
            .setQueryStatus("status", target)
            .filterRowsByAll();
        const newTotalPages = paginationHandler.getTotalPages();
        setTotalPages(newTotalPages);
        gotoPage(0);
        setData(paginationHandler.setPageIndex(0).getRows());
        setLoading(false);
    };

    const triggerSearch = React.useCallback(() => {
        setLoading(true);
        setQueryString(keyword);
        paginationHandler
            .resetRows()
            .setQueryString("email", keyword)
            .filterRowsByAll();
        gotoPage(0);
        setData(paginationHandler.setPageIndex(0).getRows());
        const newTotalPages = paginationHandler.getTotalPages();
        const counts = {
            all: paginationHandler.getStatuslessRows().length,
            [statuses[0]]: paginationHandler
                .getStatuslessRows()
                .filter((x) => x && x.status === 0).length,
            [statuses[1]]: paginationHandler
                .getStatuslessRows()
                .filter((x) => x && x.status && x.status === 1).length,
            [statuses[2]]: paginationHandler
                .getStatuslessRows()
                .filter((x) => x && x.status && x.status === 2).length,
            [statuses[3]]: paginationHandler
                .getStatuslessRows()
                .filter((x) => x && x.status && x.status === 3).length,
        }
        setElementCounts(counts);
        setTotalPages(newTotalPages);
        setLoading(false);
    }, [gotoPage, keyword, paginationHandler, setLoading]);

    const deleteAccreditation = React.useCallback(async (id) => {
        const decision = await modal.fire({
            title: "Delete Guest Accreditation",
            text: "Are you sure to delete this guest accreditation?",
            showCancelButton: true,
            confirmButtonText: `Delete`,
        });
        if (decision.isConfirmed) {
            try {
                const result = await apiHelper.hkiff.deleteGuestById(id);
                if (result.data.code === 0) {
                    toast.dark("Guest accreditation deleted.");
                }
                await getGuests();
            } catch (err) {
                console.log(err);
            }
        }
    }, [rows, actionType, getGuests]);

    const handleBulkAction = React.useCallback(async () => {
        switch (actionType) {
            case "DELETE":
                const ids = selectedFlatRows.map((o) => o.original.id);
                if (ids.length > 0) {
                    const decision = await modal.fire({
                        title: "Delete Guest Accreditation",
                        text: `Are you sure to delete ${ids.length} guest accreditations(s)?`,
                        showCancelButton: true,
                        confirmButtonText: `Delete`,
                    });
                    if (decision.isConfirmed) {
                        try {
                            const promises = ids.map((id) =>
                                apiHelper.hkiff.deleteGuestById(id)
                            );
                            await Promise.all(promises);
                            toast.dark(`${ids.length} guest accreditation(s) deleted.`);
                            await getGuests();
                        } catch (err) {
                            console.log(err);
                        }
                    }
                }
                break;
            default:
                break;
        }
    }, [rows, actionType, getGuests]);

    return (
        <div className={classes.content}>
            <Typography variant="h4" gutterBottom>
                Accreditation &gt; Guest Accreditation
            </Typography>
            <Tabs
                value={activeTab}
                onChange={handleChange}
                aria-label="nav tabs example"
                TabIndicatorProps={{
                    style: {
                        top: "0",
                        background: "#306F9D"
                    }
                }}
            >
                <Tab label="Guest" {...a11yProps(0)} />
                <Tab
                    label="Email template" {...a11yProps(1)} />
                <Tab
                    label="Sender Settings" {...a11yProps(2)} />
            </Tabs>
            <form>
                <TabPanel value={activeTab} index={0}>
                    <StatusFilter>
                        <li>
                            <button
                                className={status === null ? "active" : ""}
                                type="button"
                                onClick={statusFilterHandler(null)}
                            >
                                <Typography variant="p">All
                                    ({elementCounts.all})</Typography>
                            </button>
                        </li>
                        <li>
                            <button
                                className={status === statuses[0] ? "active" : ""}
                                type="button"
                                onClick={statusFilterHandler(statuses[0])}
                            >
                                <Typography variant="p">
                                    {statuses[0]}
                                    ({elementCounts[statuses[0]]})
                                </Typography>
                            </button>
                        </li>
                        <li>
                            <button
                                className={status === statuses[1] ? "active" : ""}
                                type="button"
                                onClick={statusFilterHandler(statuses[1])}
                            >
                                <Typography variant="p">
                                    {statuses[1]}
                                    ({elementCounts[statuses[1]]})
                                </Typography>
                            </button>
                        </li>
                        <li>
                            <button
                                className={status === statuses[2] ? "active" : ""}
                                type="button"
                                onClick={statusFilterHandler(statuses[2])}
                            >
                                <Typography variant="p">
                                    {statuses[2]}
                                    ({elementCounts[statuses[2]]})
                                </Typography>
                            </button>
                        </li>
                        <li>
                            <button
                                className={status === statuses[3] ? "active" : ""}
                                type="button"
                                onClick={statusFilterHandler(statuses[3])}
                            >
                                <Typography variant="p">
                                    {statuses[3]}
                                    ({elementCounts[statuses[3]]})
                                </Typography>
                            </button>
                        </li>
                    </StatusFilter>
                    <Grid
                        container
                        justify="space-between"
                        style={{padding: "0 25px 10px"}}
                    >
                        <Grid container item xs={3} md={3}>
                            <Box width="100%"
                                 component="span"
                                 display="flex">
                                <Box width="100%">
                                    <FormControl fullWidth
                                                 margin="dense"
                                                 variant="outlined">
                                        <InputLabel
                                            id="demo-simple-select-outlined-label">
                                            Bulk Actions
                                        </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label"
                                            id="demo-simple-select-outlined"
                                            value={actionType}
                                            onChange={handleSelectChange}
                                            label="Bulk Actions"
                                        >
                                            <MenuItem
                                                value="">
                                                <em>None</em>
                                            </MenuItem>
                                            <MenuItem
                                                value={"DELETE"}>Delete</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box display="flex">
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={handleBulkAction}
                                        disabled={disabled}
                                    >
                                        Apply
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid container item xs={12} md={8}>
                            <Box
                                width="100%"
                                component="span"
                                display="flex"
                                justifyContent="flex-end"
                                alignItems="center"
                            >
                                <Box display="flex" gap={2}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="button"
                                        component={"a"}
                                        download
                                        href={`${
                                            process.env.REACT_APP_API_HOSTNAME ||
                                            "https://hkiff-api-dev.cloud.udev.hk"
                                        }/hkiff/admin/guest-accreditation/excelExport${getKeyword(
                                            queryString
                                        )}`}
                                    >
                                        Export Accreditation
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="button"
                                        onClick={handleImportPasscode}
                                    >
                                        Import Passcode
                                    </Button>
                                    <input
                                        id="import-passcode-file"
                                        type="file"
                                        accept=".xlsx,.xls"
                                        style={{ display: 'none' }}
                                        onChange={handleFileUpload}
                                    />
                                </Box>
                                <Box display="flex">
                                    <TextField
                                        id="outlined-error"
                                        label="Search"
                                        variant="outlined"
                                        margin="dense"
                                        value={keyword}
                                        onChange={(e) => setKeyword(e.target.value)}
                                    />
                                </Box>
                                <Box display="flex">
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        type="button"
                                        margin="dense"
                                        onClick={triggerSearch}
                                    >
                                        Search
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container xs={12}>
                        <TableContainer
                            component={Paper}
                            style={{
                                margin: "0 25px",
                                boxShadow: "none",
                                border: "1px solid #cccccc",
                            }}
                        >
                            <fieldset disabled={disabled}
                                      className="fieldset">
                                <Table
                                    aria-label="simple table"
                                    component="ul"
                                    style={{margin: "0"}}
                                    {...getTableProps()}
                                >
                                    <TableHead
                                        component="div">
                                        {headerGroups.map((headerGroup) => (
                                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map((column) => (
                                                    <TableCell
                                                        {...column.getHeaderProps()}
                                                        className={`${column.className ?? ""}`}
                                                        style={{
                                                            paddingTop: 6,
                                                            paddingBottom: 6,
                                                            lineHeight: "1.1em",
                                                            height: "48px",
                                                        }}
                                                    >
                                                        {column.render("Header")}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row, index) => {
                                            prepareRow(row);
                                            return (
                                                <TableRow {...row.getRowProps()}>
                                                    {row.cells.map((cell) => {
                                                        return (
                                                            <TableCell
                                                                {...cell.getCellProps()}
                                                                className={`${cell.column.className ?? ""}`}
                                                                style={{
                                                                    paddingTop: 6,
                                                                    paddingBottom: 6,
                                                                    lineHeight: "1.1em",
                                                                    height: "48px",
                                                                }}
                                                            >
                                                                {cell.render("Cell")}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </fieldset>
                        </TableContainer>
                    </Grid>
                    <Grid
                        container
                        justify="flex-end"
                        style={{
                            paddingRight: "25px",
                            marginTop: "15px"
                        }}
                    >
                        <div className={classes.flexRow}>
                            <div></div>
                            <PaginationBarForHandler
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                setData={setData}
                                setTotalPages={setTotalPages}
                                paginationHandler={paginationHandler}
                                gotoPage={gotoPage}
                                pageIndex={pageIndex}
                                canPreviousPage={canPreviousPage}
                                previousPage={previousPage}
                                nextPage={nextPage}
                                canNextPage={canNextPage}
                                elementCounts={elementCounts}
                                status={status}
                            />
                        </div>
                    </Grid>
                </TabPanel>
                <TabPanel value={activeTab} index={1}>
                    {editEmailTemplate ? (
                        <EmailTemplateEdit
                            getTemplateApi={apiHelper.hkiff.getGuestTemplates}
                            onSubmitApi={apiHelper.hkiff.saveGuestTemplate}
                            setLoading={setLoading}
                            match={match}
                            setDisabled={setDisabled}
                        />
                    ) : (
                        <EmailTemplateListing
                            classes={classes}
                            setLoading={setLoading}
                            CustomLink={CustomLink}
                            IndeterminateCheckbox={IndeterminateCheckbox}
                            match={match}
                            disabled={disabled}
                            getTemplateApi={apiHelper.hkiff.getGuestTemplates}
                        />
                    )}
                </TabPanel>
                <TabPanel value={activeTab} index={2}>
                    <SenderSettings
                        classes={classes}
                        setLoading={setLoading}
                        disabled={disabled}
                        getConfigApi={apiHelper.hkiff.getGuestConfig}
                        saveConfigApi={apiHelper.hkiff.updateGuestConfig}
                    />
                </TabPanel>
            </form>
        </div>
    );
}

export default GuestAccreditationPage;
